'use client';
import { CountryResponseProps } from '@components/shared.types';
import { ExpSearchInput } from '@license-admin/boldjobs';
import { isRCPortal } from 'helper';
import * as React from 'react';
import { useCallback, useRef } from 'react';
import { US_GLOBAL_LOCATION, searchStaticList } from '../constant';
import SearchInput from './SearchInput';
import {
  FilterBtn,
  InputIcon,
  InputWrap,
  SearchBtn,
  SearchWrap,
  Select,
  Styledform,
} from './styled';

interface Props {
  selectedCountry?: string;
  searchParam: string;
  locParam: string;
  type?: string;
  location?: string;
  isMobile?: boolean;
  isHeader?: boolean;
  searchResults?: any;
  searchLocResults?: string[];
  changeHandler: (_e: React.ChangeEvent<HTMLInputElement>) => void;
  changeLocHandler: (_e: React.ChangeEvent<HTMLInputElement>) => void;
  selectSearchResult: (_e: React.SyntheticEvent, _result: string) => void;
  selectLocResult: (_e: React.SyntheticEvent, _result: string) => void;
  onSearchClick: (_e: React.SyntheticEvent) => void;
  selectedIndex?: any;
  setSelectedIndex?: any;
  setSearchParam?: any;
  setSearchResults?: any;
  setLocParam?: any;
  setInputVal?: any;
  setSearchLocResults?: any;
  setSelectedCountry?: any;
  selectedLocIndex?: any;
  setSelectedLocIndex?: any;
  countyList?: CountryResponseProps[];
  isSearchFilter?: boolean;
  isSearchButtonPressed?: boolean;
  isRCPortal?: boolean;
  isRemoteJobsPage?: boolean;
  isCategoryPage?: boolean;
  isAddStaticSearchList?: boolean;
  openList?: boolean;
  setOpenList?: any;
  setFilter?: any;
  isShowFilter?: boolean;
  isMobileView?: boolean;
  themeType?: string;
  isExpSavedSearchDropDown?: boolean;
  setInputParams?: any;
}

const SearchFilter = (props: Props) => {
  const searchJobRef = useRef<HTMLDivElement>(null!);
  const searchLocationRef = useRef<HTMLDivElement>(null!);
  const { isMobileView } = props;

  const toggleFilter = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.preventDefault();
      props.setFilter && props.setFilter(!props.isShowFilter);
    },
    [props.isShowFilter, props.setFilter]
  );

  const handleSearchSubmit = useCallback(
    (e: React.SyntheticEvent) => {
      props.onSearchClick(e);
    },
    [props.onSearchClick]
  );

  const isCountryLocation = Boolean(
    props.selectedCountry &&
      !US_GLOBAL_LOCATION.US_LOC?.includes(props.selectedCountry)
  );
  const labelText = !isMobileView ? 'Search by location' : 'Location';
  return (
    <Styledform onSubmit={handleSearchSubmit}>
      <SearchWrap
        $isHeader={props.isHeader}
        $isSelectedCountry={isCountryLocation}
      >
        <InputWrap $isHeader={props.isHeader} $isJobTitleBox={true}>
          <InputIcon className="fa-solid fa-magnifying-glass" />
          {props.isExpSavedSearchDropDown ? (
            <ExpSearchInput
              searchParam={props.searchParam}
              changeHandler={props.changeHandler}
              setOpenList={props.setOpenList}
              placeholder={
                !isMobileView ? 'Search by keyword or job title' : 'Keyword'
              }
              ariaLabel={
                isMobileView
                  ? 'Search for Jobs...'
                  : 'Search by job title, keyword, etc.'
              }
              bdrcurve={true}
              setInputVal={props.setInputVal}
              searchResults={props.searchResults}
              setSearchParam={props.setSearchParam}
              setSearchResults={props.setSearchResults}
              inputRef={searchJobRef}
              searchDataOnClick={props.onSearchClick}
              selectSearchResult={props.selectSearchResult}
              height={isMobileView ? '4.8rem' : '7rem'}
              borderRight
              id="search-jobs"
              isHeader={props.isHeader}
              isRCPortal={props.isRCPortal}
              setInputParams={props.setInputParams}
            />
          ) : (
            <SearchInput
              searchParam={props.searchParam}
              changeHandler={props.changeHandler}
              setOpenList={props.setOpenList}
              placeholder={
                !isMobileView ? 'Search by keyword or job title' : 'Keyword'
              }
              ariaLabel={
                isMobileView
                  ? 'Search for Jobs...'
                  : 'Search by job title, keyword, etc.'
              }
              bdrcurve={true}
              setInputVal={props.setInputVal}
              searchResults={props.searchResults}
              setSearchParam={props.setSearchParam}
              setSearchResults={props.setSearchResults}
              inputRef={searchJobRef}
              searchDataOnClick={props.onSearchClick}
              selectSearchResult={props.selectSearchResult}
              height={isMobileView ? '4.8rem' : '7rem'}
              borderRight
              id="search-jobs"
              isHeader={props.isHeader}
              isRCPortal={props.isRCPortal}
              isExpSavedSearchDropDown={props.isExpSavedSearchDropDown}
            />
          )}
        </InputWrap>
        <InputWrap
          $isHeader={props.isHeader}
          $isJobTitleBox={isCountryLocation}
        >
          <InputIcon className="fa-regular fa-location-dot" />

          <SearchInput
            searchParam={props.locParam}
            openList={props.openList}
            setOpenList={props.setOpenList}
            showListOnFocus={props.isAddStaticSearchList}
            changeHandler={props.changeLocHandler}
            setInputVal={props.setInputVal}
            placeholder={labelText}
            ariaLabel={labelText}
            searchResults={props.searchLocResults}
            setSearchParam={props.setLocParam}
            inputRef={searchLocationRef}
            setSearchResults={props.setSearchLocResults}
            selectSearchResult={props.selectLocResult}
            searchDataOnClick={props.onSearchClick}
            searchStaticList={
              props.isAddStaticSearchList ? searchStaticList : []
            }
            height={isMobileView ? '4.8rem' : '7rem'}
            borderRight
            id="search-by-location"
            isHeader={props.isHeader}
            isRCPortal={props.isRCPortal}
            isborderRight={props.isRCPortal}
            isSelectCountry={
              props.isRCPortal &&
              props.selectedCountry &&
              !US_GLOBAL_LOCATION.US_LOC?.includes(props.selectedCountry)
            }
          />
        </InputWrap>
        {isCountryLocation && (
          <InputWrap $isHeader={props.isHeader}>
            <InputIcon className="fa-regular fa-location-dot" />
            <Select
              id="select-country"
              $borderRight
              aria-label="Select Country"
              onChange={(e) => props.setSelectedCountry(e.target.value)}
              $isSearchFilter={props.isSearchFilter}
              $isborderRight={props.isRCPortal}
              $isRCPortal={isRCPortal}
              $isCountryLocation={true}
            >
              <option value="">Select Country</option>
              <option value="Anywhere">
                Anywhere (can be done from anywhere worldwide)
              </option>
              {props.countyList?.map(
                (item: CountryResponseProps, index: number) => (
                  <option
                    selected={
                      props.selectedCountry?.toLowerCase() ===
                      item.countryName.toLowerCase()
                        ? true
                        : false
                    }
                    key={`country-${item.countryName}` + index}
                    value={item.countryName}
                  >
                    {item.countryName}
                  </option>
                )
              )}
            </Select>
          </InputWrap>
        )}
        <SearchBtn
          id="submit-search"
          type="submit"
          aria-label="Search"
          aria-pressed={props.isSearchButtonPressed}
          $isHeader={props.isHeader}
          $isSearchFilter={props.isSearchFilter}
          className="show-content"
          $isRCPortal={props.isRCPortal}
          $themeType={props.themeType !== 'wlb'}
        >
          {!isMobileView ? 'Search' : <i className="fa fas fa-search "></i>}
        </SearchBtn>
        {!isMobileView && (
          <FilterBtn
            onClick={toggleFilter}
            aria-label="Show filters"
            id="btn-filter"
          >
            <i className="fa-classic fa-solid fa-sliders" aria-hidden="true" />
          </FilterBtn>
        )}
      </SearchWrap>
    </Styledform>
  );
};

export default SearchFilter;
